import { useSelector } from 'react-redux';
import { FeatureFlagData, FeatureFlagEnvConfig, FLAGS } from '../../../types/featureFlag';
import { store } from '../../../redux/store';

type Env = 'development' | 'production' | 'quality' | 'staging' | 'security' | '';

const CURRENT_ENV: Env = (() => {
  const env = process.env.REACT_APP_ENV?.toLowerCase();
  if (env === 'qa') return 'quality';
  if (env === 'beta') return 'staging';
  if (env === 'production') return 'production';
  if (env === 'development') return 'development';
  if (env === 'security') return 'security';
  return '';
})();

export const useFeatureFlag = (flagName: FLAGS): boolean => {
  const CURRENT_USER = store.getState()?.userDetailsReducer?.userDetails?.email || '';
  const flag = useSelector((state: any) => {
    const allFlags = (state.featureFlagReducer?.flags ?? {}) as FeatureFlagData;
    return allFlags[flagName];
  });
  if (!flag?.active) return false;
  if (CURRENT_ENV === '') return false;
  const envConfig = flag[CURRENT_ENV] as FeatureFlagEnvConfig | undefined;
  console.log({ CURRENT_USER, e: envConfig, CURRENT_ENV, flag });
  if (!envConfig) return false;
  console.log(envConfig.wildentry);
  if (envConfig.wildentry) return true;
  console.log(envConfig.allowedUsers.includes(CURRENT_USER));
  if (envConfig.allowedUsers.includes(CURRENT_USER)) return true;
  return false;
};
